import { CoreApi, NightLightsSystem } from '@inter-ikea-storageone/range';
import { Feature, RenderLocation, RendersComponent } from '../../../../features/Feature';
import NightLightsWidget from './NightLightsWidget';
import LightsAction from 'components/SceneMenu/actions/LightsAction';

export class NightLightsFeature extends Feature implements RendersComponent {
  protected init(coreApi: CoreApi): void {
    coreApi.registerSystem(new NightLightsSystem(coreApi, 7));
  }

  render(location: RenderLocation) {
    switch (location) {
      case RenderLocation.Root:
        return NightLightsWidget;
      case RenderLocation.Action:
        return LightsAction;
    }
  }
}
